import PropTypes from "prop-types";
import React from "react";
import { Box, Typography } from "@mui/material";
import WarningModal from "./WarningModal";
import { useTranslation } from "react-i18next";

const AddRepoItemVersionConfirmationModal = ({
  open,
  onClose,
  onSubmit,
  courseNames
}) => {
  const { t } = useTranslation();

  return (
    <WarningModal
      open={open}
      warningMessage={
        <Box display="flex" flexDirection="column">
          <Typography>
            {t("manageRepository.addVersionConfirmation.msg1")}
          </Typography>
          <ul>
            {(courseNames || []).map(courseName => (
              <li key={courseName}>
                <Typography variant="body2">{courseName}</Typography>
              </li>
            ))}
          </ul>
          <Typography sx={{ mt: 1.5 }} variant="subtitle1">
            {t("manageRepository.addVersionConfirmation.msg2")}
          </Typography>
        </Box>
      }
      onClose={onClose}
      onSubmit={onSubmit}
      hideWarningIcon
      title={
        <Typography variant="h4" color="textPrimary">
          {t("manageRepository.addVersionConfirmation.title")}
        </Typography>
      }
    />
  );
};

AddRepoItemVersionConfirmationModal.propTypes = {
  /**
   * Called to close the Modal
   */
  onClose: PropTypes.func,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the OK button is pressed
   */
  onSubmit: PropTypes.func,
  /**
   * The courses associated to the repo item
   */
  courseNames: PropTypes.arrayOf(PropTypes.string)
};

AddRepoItemVersionConfirmationModal.defaultProps = {
  open: false
};

export default AddRepoItemVersionConfirmationModal;
